<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-style__classstyle">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.creatorName" clearable placeholder="上传人"></el-input>
        </el-form-item>

        <el-form-item>
        <el-select
                v-model="dataForm.classId"
                placeholder="请选择班级"
                clearable
                filterable
        >
          <el-option
                  v-for="classManager in classList"
                  :label="classManager.className"
                  :value="classManager.id"
                  :key="classManager.id"
          >
          </el-option>
        </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
       <!-- <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>-->
        <el-form-item>
          <el-button v-if="$hasPermission('style:classstyle:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('style:classstyle:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="creatorName" label="上传人名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="phone" label="手机号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="className" label="班级" header-align="center" align="center"></el-table-column>
        <el-table-column prop="auditStatus" label="审核状态" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.auditStatus===auditStatus.examine">审核中</el-tag>
            <el-tag type="success" v-if="scope.row.auditStatus===auditStatus.passed">已通过</el-tag>
            <el-tag type="danger" v-if="scope.row.auditStatus===auditStatus.fail">未通过</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="context" label="内容描述" header-align="center" align="center"></el-table-column>
        <el-table-column prop="link" label="链接" header-align="center" align="center"></el-table-column>
        <el-table-column prop="imgSrc" label="图片" header-align="center" align="center">
          <template slot-scope="scope">
            <el-image   @click.stop="handleClickItem" :preview-src-list="scope.row.imgList" v-if="scope.row.imgList!==null" style="width: 100px; height: 100px" :src="scope.row.imgList!==null?scope.row.imgList[0]:''" fit="cover"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="videoSrc" label="视频地址" header-align="center" align="center">
          <template slot-scope="scope">
            <video
                    ref="videoEle"
                    preload="auto"
                    id='my-video'
                    v-if="scope.row.videoSrc!==''"
                    :src="scope.row.videoSrc"
                    :playsinline="true"
                    :webkit-playsinline="true"
                    autoplay
                    muted
                    :x-webkit-airplay="true"
                    x5-video-player-type="h5"
                    :x5-video-player-fullscreen="true"
                    controls="controls"
                    :x5-video-ignore-metadata="true"
                    width="96%"
                    height="150"
            >
            </video>
          </template>
        </el-table-column>
        <el-table-column prop="sponsorNum" label="点赞数" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createDate" label="上传时间" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('style:classstyle:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('style:classStyle:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './classstyle-add-or-update'
import { auditStatus } from '../../../constant'
import Template from '../devtools/template'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/classStyle/page',
        getDataListIsPage: true,
        exportURL: '/style/classStyle/export',
        deleteURL: '/style/classStyle',
        deleteIsBatch: true
      },
      classList: [],
      auditStatus,
      dataForm: {
        creatorName: ''
      }
    }
  },
  mounted () {
    this.getClassList()
  },
  methods: {
    handleClickItem () {
      this.$nextTick(() => {
        const domImageMask = document.querySelector('.el-image-viewer__mask') // 获取遮罩层dom
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    // 获取信息
    getClassList () {
      this.$http
        .get('/classmanage/classmanage/getList')
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.classList = res.data
          console.log(res.data)
        })
        .catch(() => {
        })
    }
  },
  watch: {
  },
  components: {
    Template,
    AddOrUpdate
  }
}
</script>
